import React from 'react';
import CardProductRating from '../CardProductRating/CardProductRating';
import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
const CardBlockProductRating = ({...props}) => {
    let list = [];
    if(props.list !== undefined){
        list = props.list        
    }

    const renderCards = () => (
        list.map((card,index) => (
            <CardProductRating key={index} {...card} widthDetail="220" />
        ))
    )
    
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'VND',
        minimumFractionDigits: 0
    })

    const totalPriceCart = () => {
        //Local Storage sessionProducts
        let sessionProducts = []
        if(JSON.parse(localStorage.getItem('sessionProducts')))
          sessionProducts = JSON.parse(localStorage.getItem('sessionProducts'))
        else 
          sessionProducts = []

        let total = 0
        sessionProducts.forEach((element) => {
            total += element.quantity*element.price
        }) 
        if(props.type == "confirm"){
            return(
                <div className="row">
                    <div className="col d-flex justify-content-end" style={{ paddingRight:60, fontSize:18 }}>
                        Tổng cộng: <b style={{ paddingLeft:5 }}> {formatter.format(total)} </b>
                    </div>
                </div>
            )
        }
    }

    return (
        <>
        <div className="container" style={{ marginTop:50 }}>
            <div className="row" id="hideTop">
                <div className="col-md-4 text-center">
                    Sản Phẩm
                </div>
                <div className="col-md-8 text-center">
                    <div className="row">
                        <div className="col-md-6 text-center">
                            Đơn Giá
                        </div>
                        <div className="col-md-6 text-center">
                            Đánh Giá
                        </div>
                    </div>
                </div>
            </div>
            <hr className="divider" />
            <div style={{ display:'flex', flexDirection:'column' }}>
                {renderCards(props.list)}
            </div>
            <div>
                { totalPriceCart() }
            </div>
        </div>
        </>
    )
};

export default CardBlockProductRating;